module.exports = __webpack_public_path__ + "img/image 4.ffe599e7.png";